import { FC } from 'react';
import { useCart } from '../../../lib/context/cart/CartContext';
import { useChat } from '../../../lib/context/chat/ChatContext';
import { Button } from '../../atoms/Button';

import styles from './ChangePlanComponent.module.css';

export const ChangePlanComponent: FC = () => {
    const { plan, toggleChangePlan } = useChat();
    const { getCartCount } = useCart();
    const cartQty = getCartCount();
    const remainingMeals = (plan?.mealsPerDelivery || 0) - cartQty;

    const handleOnClick = () => {
        toggleChangePlan(true);
    }

    return (
        <div className={styles.changePlanComponent}>
            <div className={styles.changePlanImage}>
                <img src="https://static.cookunity.com/ai-waiter/images/change-plan.png" alt="Change plan" />
            </div>
            <div className={styles.changePlanDetails}>
                <div>
                    <h2>Change Plan</h2>
                    <p>
                        Modify your plan size anytime to fit your needs.
                    </p>
                </div>
                <hr />
                <div>
                    <p>
                        Current plan:
                    </p>
                    <p className={styles.changePlanMeals}>
                        {plan?.mealsPerDelivery} meals
                    </p>
                    <Button className={styles.changePlanAction} onClick={handleOnClick}>
                        {remainingMeals > 0 ? (
                            'Change Plan'
                        ) : (
                            'Upgrade to have more meals'
                        )}
                        {/* Change Plan
                        Upgrade to an 8 meals plan */}
                    </Button>
                </div>
            </div>
        </div >
    );
};